import React, { useState } from "react";
import { connect } from "react-redux";
import { setAuthentification } from "../actions/index";
import { Link, withRouter } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Form, Button } from 'react-bootstrap';
import requireUserAdmin from "../helpers/requireUserAdmin";

const AdminNavDropdown = requireUserAdmin(NavDropdown, 1, 6);

// Cache mémoire stabilisé pour éviter la boucle infinie et gérer la déconnexion
let cachedUserStr = null;
let cachedUserObj = null;

const getStoredUser = () => {
  const stored = localStorage.getItem('user');
  if (!stored) {
    cachedUserStr = null;
    cachedUserObj = null;
    return null;
  }
  if (stored === cachedUserStr) return cachedUserObj;
  try {
    cachedUserStr = stored;
    cachedUserObj = JSON.parse(stored)?.[0] || null;
    return cachedUserObj;
  } catch {
    return null;
  }
};

const Header = ({ isLoggedIn, setAuthentification, history, user }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [navExpanded, setNavExpanded] = useState(false);

  // Définition des rôles
  const idUser = Number(user?.id ?? user?.id_user);
  const role = Number(user?.role);

  const isCommercial = role === 5 || [150, 216].includes(idUser);
  const isAtelier = role === 6;
  const isAdmin = role === 1 || (role === 6 && !isAtelier); // Correction ESLint des opérateurs mélangés

  const logout = (e) => {
    e.preventDefault();
    setNavExpanded(false);
    setOpenDropdown(null);
    setAuthentification(false);
    localStorage.removeItem('user');
    history.push("/");
  };

  // Se base sur l'état demandé (isOpen) plutôt que de "toggle" à l'aveugle :
  // évite qu'un rootClose (fermeture du menu précédent) écrase l'ouverture du menu cliqué
  // lorsque les deux événements arrivent dans le même batch React.
  const handleDropdownToggle = (dropdownId, isOpen) => {
    setOpenDropdown(prev => {
      if (isOpen) return dropdownId;
      return prev === dropdownId ? null : prev;
    });
  };

  const handleCloseDropdown = () => {
    setOpenDropdown(null);
    setNavExpanded(false);
  };

  const handleExternalLink = (url) => {
    handleCloseDropdown();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const navStyle = {
    maxHeight: navExpanded ? '80vh' : 'none',
    overflowY: navExpanded ? 'auto' : 'visible',
  };

  return (
    <Navbar expanded={navExpanded} onToggle={setNavExpanded} bg="light" expand="xl" style={{ zIndex: 200 }}>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" style={navStyle}>
        <Nav className="mr-auto">
          {isLoggedIn && (
            <>
              {/* --- 1. ACCÈS COMMERCIAL (Rôle 5) --- */}
              {isCommercial && (
                <Link onClick={handleCloseDropdown} to="/commercial" className="nav-link">Relevé Heures</Link>
              )}

              {/* --- 2. ACCÈS ATELIER (Rôle 6) --- */}
              {isAtelier && (
                <>
                  <NavDropdown title="Suivi" id="nav-suivi" show={openDropdown === 'suivi'} onToggle={(isOpen) => handleDropdownToggle('suivi', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/filter" className="nav-link nav-child">Suivi Commande</Link>
                    <Link onClick={handleCloseDropdown} to="/suivi_prod" className="nav-link nav-child">Suivi Production</Link>
                  </NavDropdown>

                  <NavDropdown
                    title="Atelier"
                    id="nav-atelier"
                    show={openDropdown === 'atelier'}
                    onToggle={(isOpen) => handleDropdownToggle('atelier', isOpen)}
                  >
                    <Link onClick={handleCloseDropdown} to="/finaliser" className="nav-link nav-child">Finaliser</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/envoi" className="nav-link nav-child">Envoi / Retour Atelier</Link>
                    <Link onClick={handleCloseDropdown} to="/serti/envoi" className="nav-link nav-child">Envoi / Retour Serti</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/boite_or" className="nav-link nav-child">Boite Or</Link>
                    <Link onClick={handleCloseDropdown} to="/mouvements_or" className="nav-link nav-child">Mouvements Or</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/pesee" className="nav-link nav-child">Pesée Or</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/analyse_ouvrier" className="nav-link nav-child">Analyse Atelier</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier" className="nav-link nav-child">Atelier</Link>
                  </NavDropdown>

                  <NavDropdown title="Produit" id="nav-produit" show={openDropdown === 'produit'} onToggle={(isOpen) => handleDropdownToggle('produit', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/produit" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/cv" className="nav-link nav-child">Centre Vide</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/centre" className="nav-link nav-child">Centre</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/stock" className="nav-link nav-child">Stock</Link>
                    <Link onClick={handleCloseDropdown} to="/reservation" className="nav-link nav-child">Reservation Collection</Link>
                    <Link onClick={handleCloseDropdown} to="/devis" className="nav-link nav-child">Devis</Link>
                  </NavDropdown>

                  <NavDropdown title="OF" id="nav-of" show={openDropdown === 'of'} onToggle={(isOpen) => handleDropdownToggle('of', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/of/tracer" className="nav-link nav-child">Tracer OF</Link>
                    <Link onClick={handleCloseDropdown} to="/of/edit" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/of" className="nav-link nav-child">Création</Link>
                    <Link onClick={handleCloseDropdown} to="/planning" className="nav-link nav-child">Planning</Link>
                    <Link onClick={handleCloseDropdown} to="/of/tools" className="nav-link nav-child">OF Tools</Link>
                    <Link onClick={handleCloseDropdown} to="/of/besoin" className="nav-link nav-child">Edition de Besoin</Link>
                  </NavDropdown>

                  <NavDropdown
                    title="Pierre"
                    id="nav-pierre"
                    show={openDropdown === 'pierre'}
                    onToggle={(isOpen) => handleDropdownToggle('pierre', isOpen)}
                  >
                    <Link onClick={handleCloseDropdown} to="/pierre" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/reception" className="nav-link nav-child">Reception</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/sortie" className="nav-link nav-child">Alimenter</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/retour" className="nav-link nav-child">Retourner</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/stock" className="nav-link nav-child">Stock</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/analyse_conso" className="nav-link nav-child">Analyse Conso</Link>
                  </NavDropdown>

                  <NavDropdown
                    title="Impression"
                    id="nav-impression"
                    show={openDropdown === 'impression'}
                    onToggle={(isOpen) => handleDropdownToggle('impression', isOpen)}
                  >
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/referencier.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Referencier</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/impression_ligne.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Lignes</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/tourDeDoigtPrinter.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Alliance Doigt</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/livre_police.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Livre de Police</span>
                  </NavDropdown>
                </>
              )}

              {/* --- 3. ACCÈS ACCORDÉ À L'ADMINISTRATEUR (Rôle 1) --- */}
              {isAdmin && (
                <>
                  <AdminNavDropdown title="Administration" id="nav-admin" show={openDropdown === 'admin'} onToggle={(isOpen) => handleDropdownToggle('admin', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/cours" className="nav-link nav-child">Cours</Link>
                    <Link onClick={handleCloseDropdown} to="/administration/clients" className="nav-link nav-child">Clients</Link>
                    <Link onClick={handleCloseDropdown} to="/svg" className="nav-link nav-child">SVG</Link>
                    <Link onClick={handleCloseDropdown} to="/wp" className="nav-link nav-child">WP</Link>
                    <Link onClick={handleCloseDropdown} to="/administration/doublon-pierre" className="nav-link nav-child">Doublons Pierre</Link>
                    <Link onClick={handleCloseDropdown} to="/commercial" className="nav-link nav-child">Relevé Heures</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Produit" id="nav-produit" show={openDropdown === 'produit'} onToggle={(isOpen) => handleDropdownToggle('produit', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/produit" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/cv" className="nav-link nav-child">Centre Vide</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/centre" className="nav-link nav-child">Centre</Link>
                    <Link onClick={handleCloseDropdown} to="/produit/stock" className="nav-link nav-child">Stock</Link>
                    <Link onClick={handleCloseDropdown} to="/reservation" className="nav-link nav-child">Reservation Collection</Link>
                    <Link onClick={handleCloseDropdown} to="/devis" className="nav-link nav-child">Devis</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="OF" id="nav-of" show={openDropdown === 'of'} onToggle={(isOpen) => handleDropdownToggle('of', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/of/tracer" className="nav-link nav-child">Tracer OF</Link>
                    <Link onClick={handleCloseDropdown} to="/of/edit" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/of" className="nav-link nav-child">Création</Link>
                    <Link onClick={handleCloseDropdown} to="/planning" className="nav-link nav-child">Planning</Link>
                    <Link onClick={handleCloseDropdown} to="/of/tools" className="nav-link nav-child">OF Tools</Link>
                    <Link onClick={handleCloseDropdown} to="/of/besoin" className="nav-link nav-child">Edition de Besoin</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="FACTURATION" id="nav-facturation" show={openDropdown === 'facturation'} onToggle={(isOpen) => handleDropdownToggle('facturation', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/livraison" className="nav-link nav-child">Facturer</Link>
                    <Link onClick={handleCloseDropdown} to="/avoir" className="nav-link nav-child">Avoir</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Suivi" id="nav-suivi" show={openDropdown === 'suivi'} onToggle={(isOpen) => handleDropdownToggle('suivi', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/filter" className="nav-link nav-child">Suivi Commande</Link>
                    <Link onClick={handleCloseDropdown} to="/suivi_prod" className="nav-link nav-child">Suivi Production</Link>
                    <Link onClick={handleCloseDropdown} to="/suivi_connection" className="nav-link nav-child">Connexions</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="ANALYSE" id="nav-analyse" show={openDropdown === 'analyse'} onToggle={(isOpen) => handleDropdownToggle('analyse', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/analyse_ca" className="nav-link nav-child">Analyse CA</Link>
                    <Link onClick={handleCloseDropdown} to="/compta/compte_poids" className="nav-link nav-child">Compte Poids Clients</Link>
                    <Link onClick={handleCloseDropdown} to="/analyse_stock" className="nav-link nav-child">Analyse STOCK</Link>
                    <Link onClick={handleCloseDropdown} to="/comparaison_ca" className="nav-link nav-child">Comparaison CA Client</Link>
                    <Link onClick={handleCloseDropdown} to="/variation_ca_client" className="nav-link nav-child">Variation CA Client</Link>
                    <Link onClick={handleCloseDropdown} to="/analyse_prix" className="nav-link nav-child">Analyse Prix</Link>
                    <Link onClick={handleCloseDropdown} to="/facon" className="nav-link nav-child">Analyse Facon</Link>
                    <Link onClick={handleCloseDropdown} to="/analyse_fournisseur" className="nav-link nav-child">Analyse Fournisseur</Link>
                    <Link onClick={handleCloseDropdown} to="/analyse_metal" className="nav-link nav-child">Analyse Metal</Link>
                    <Link onClick={handleCloseDropdown} to="/suivi_production" className="nav-link nav-child">Suivi Production</Link>
                    <Link onClick={handleCloseDropdown} to="/import-client" className="nav-link nav-child">Import Client</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Atelier" id="nav-atelier-admin" show={openDropdown === 'atelier-admin'} onToggle={(isOpen) => handleDropdownToggle('atelier-admin', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/finaliser" className="nav-link nav-child">Finaliser</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/envoi" className="nav-link nav-child">Envoi / Retour Atelier</Link>
                    <Link onClick={handleCloseDropdown} to="/serti/envoi" className="nav-link nav-child">Envoi / Retour Serti</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/boite_or" className="nav-link nav-child">Boite Or</Link>
                    <Link onClick={handleCloseDropdown} to="/mouvements_or" className="nav-link nav-child">Mouvements Or</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/pesee" className="nav-link nav-child">Pesée Or</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier/analyse_ouvrier" className="nav-link nav-child">Analyse Atelier</Link>
                    <Link onClick={handleCloseDropdown} to="/atelier" className="nav-link nav-child">Atelier</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Pierre" id="nav-pierre-admin" show={openDropdown === 'pierre-admin'} onToggle={(isOpen) => handleDropdownToggle('pierre-admin', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/pierre" className="nav-link nav-child">Liste</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/reception" className="nav-link nav-child">Reception</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/sortie" className="nav-link nav-child">Alimenter</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/retour" className="nav-link nav-child">Retourner</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/stock" className="nav-link nav-child">Stock</Link>
                    <Link onClick={handleCloseDropdown} to="/pierre/analyse_conso" className="nav-link nav-child">Analyse Conso</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Compta" id="nav-compta" show={openDropdown === 'compta'} onToggle={(isOpen) => handleDropdownToggle('compta', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/compta" className="nav-link nav-child">Facture / Avoir</Link>
                    <Link onClick={handleCloseDropdown} to="/valorisation" className="nav-link nav-child">Valorisation Stock</Link>
                    <Link onClick={handleCloseDropdown} to="/traite" className="nav-link nav-child">Traite</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Image" id="nav-image" show={openDropdown === 'image'} onToggle={(isOpen) => handleDropdownToggle('image', isOpen)}>
                    <Link onClick={handleCloseDropdown} to="/upload" className="nav-link nav-child">Upload</Link>
                    <Link onClick={handleCloseDropdown} to="/image" className="nav-link nav-child">Gestion Image</Link>
                    <Link onClick={handleCloseDropdown} to="/affectation" className="nav-link nav-child">Affectation Image</Link>
                  </AdminNavDropdown>

                  <AdminNavDropdown title="Impression" id="nav-impression-admin" show={openDropdown === 'impression-admin'} onToggle={(isOpen) => handleDropdownToggle('impression-admin', isOpen)}>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/referencier.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Referencier</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/impression_ligne.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Lignes</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/tourDeDoigtPrinter.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Alliance Doigt</span>
                    <span onClick={() => handleExternalLink("https://extensia-france.com/printers/livre_police.php")} className="nav-link nav-child" style={{ cursor: 'pointer' }}>Livre de Police</span>
                  </AdminNavDropdown>
                </>
              )}
            </>
          )}
        </Nav>
        <Form inline>
          <Button variant="link" onClick={logout} style={{ borderRadius: "20px", padding: "5px 15px", fontSize: "16px", textDecoration: "none", color: "#333" }}>
            Déconnexion
          </Button>
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.authentification.isLoggedIn,
  user: state.authentification.user || getStoredUser()
});

const mapDispatchToProps = {
  setAuthentification,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));